import { Component, OnInit, ViewChild } from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { environment } from 'src/environments/environment';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';

import { SsoService } from 'src/app/services/sso/sso.service';

import { TarjetaModel } from 'src/app/services/ciudadanos/models/tarjeta.model';

@Component({
  selector: 'app-ciudadanos-listado-tarjetas',
  templateUrl: './ciudadanos-listado-tarjetas.component.html',
  styleUrls: ['./ciudadanos-listado-tarjetas.component.css']
})
export class CiudadanosListadoTarjetasComponent implements OnInit {
  @ViewChild('gridTarjetas') gridTarjetas: jqxGridComponent;

  private componentRef = null;

  public environment = environment;
  public langGrid = JqWidgets.getLocalization('es');

  tarjetas: TarjetaModel[] = [];

  public columnsTarjetas: any[] = [
    { text: 'NSMovisat', columntype: 'textbox', datafield: 'nsMovisat', editable: false },
    { text: this.translate('Descripcion'), columntype: 'textbox', datafield: 'descripcion', editable: false, },
    { text: this.translate('Master'), columntype: 'checkbox', datafield: 'master' },
  ];

  public sourceTarjetas = {
    datatype: 'json',
    datafields: [
      { name:'nsMovisat', type: 'string', map: 'nsMovisat' },
      { name:'descripcion', type: 'string', map: 'descripcion' },
      { name:'master', type: 'boolean', map: 'master' }
    ],
    localdata: this.tarjetas
  };

  public dataAdapterTarjetas = new jqx.dataAdapter(this.sourceTarjetas);

  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  constructor(private ssoService: SsoService) { }

  init(componentRef: any, tarjetas: TarjetaModel[]): void {
    this.componentRef = componentRef;
    this.tarjetas = tarjetas;
    this.sourceTarjetas.localdata = this.tarjetas;
    this.dataAdapterTarjetas.dataBind();


    const t = setTimeout(() => {
      clearTimeout(t);
      this.gridTarjetas.attrColumns.forEach((column: any) => {
        this.gridTarjetas.autoresizecolumn(column.datafield, column.columntype);
      });
    }, 100);
  }

  ngOnInit(): void {
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
  }
}
